import defaultLayoutComponent from '~pages/nrw/layouts/NrwDefaultLayoutComponents.js'

let routeInfo = [

  {
    path: 'payment/order',
    name: 'PaymentOrder',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/Payment.vue') }
    ),
    meta: {
      authorized: true,
      title: '수강신청 및 결제'
    }
  },
  {
    path: 'payment/result',
    name: 'PaymentDone',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentDone.vue') }
    ),
    meta: {
      authorized: true,
      title: '결제 완료'
    }
  },
  {
    path: 'payment/ars',
    name: 'PaymentArs',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentArs.vue') }
    ),
    meta: {
      authorized: true,
      title: 'ARS 안내'
    }
  },
  {
    path: 'payment/am',
    name: 'PaymentAm',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentAm.vue') }
    ),
    meta: {
      authorized: true,
      title: '정원 외 대기 신청안내'
    }
  },
  {
    path: 'payment/dwbAcnt',
    name: 'PaymentDwbAcnt',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentDwbAcnt.vue') }
    ),
    meta: {
      authorized: true,
      title: '무통장 입금 안내'
    }
  },
  {
    path: 'payment/free',
    name: 'PaymentFree',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentFree.vue') }
    ),
    meta: {
      authorized: true,
      title: '무료 안내'
    }
  },
  {
    path: 'payment/deposit',
    name: 'PaymentDeposit',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentDeposit.vue') }
    ),
    meta: {
      authorized: true,
      title: '입금 안내'
    }
  },
  {
    path: 'payment/nationDeposit',
    name: 'PaymentNationDeposit',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentNationDeposit.vue') }
    ),
    meta: {
      authorized: true,
      title: '입금 안내'
    }
  },
  {
    path: 'payment/PkgDone',
    name: 'PaymentPkgDone',
    props: true,
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentPkgDone.vue') }
    ),
    meta: {
      authorized: true,
      title: '입금 안내'
    }
  },
  {
    path: 'payment/TelCors',
    name: 'PaymentTelCors',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentTelCors.vue') }
    ),
    meta: {
      authorized: true,
      title: '수강신청 및 결제'
    }
  },
  {
    path: 'payment/SpeakCors',
    name: 'PaymentSpeakCors',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentSpeakCors.vue') }
    ),
    meta: {
      authorized: true,
      title: '수강신청 및 결제'
    }
  },
  {
    path: 'payment/AplInfo',
    name: 'PaymentAplInfo',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_payment" */ '~pages/nrw/payment/PaymentAplInfo.vue') }
    ),
    meta: {
      authorized: true,
      title: '신청정보'
    }
  }

]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/nrw/child/paymentRouter.js